class CustomBundlePDP extends HTMLElement {
    constructor() {
        super();

        this.variants = variants;

        this.currency = this.querySelector("#store-currency").value;

        this.querySelectorAll(".custom-bundle-pdp-radio").forEach((radio) =>
            radio.addEventListener("change", this.changeOption.bind(this))
        );

        this.querySelectorAll(".custom-bundle-pdp-images .custom-bundle-pdp-image").forEach((image) => image.addEventListener("click", this.changeSelectedImage.bind(this)))


        this.querySelectorAll(".custom-bundle-pdp-variant").forEach((product) => this.changeOptionsAvailability(product.getAttribute("data-product-index")));

        this.querySelector(".custom-bundle-pdp-buy-button").addEventListener("click", () => this.addToCart());

        this.setGalleryMinHeight();

        // this.observeCartDrawer();

    }

    changeOption(e) {
        const option = e.target.name;
        this.querySelectorAll(`input[name="${option}"]`).forEach((input) => {
            const id = input.id;
            this.querySelector(`label[for="${id}"]`).setAttribute("selected", "false");
        });
        this.querySelector(`label[for="${e.target.id}"]`).setAttribute("selected", "true");
        this.changeImage(e.target.getAttribute("data-index"));
        this.changeOptionsAvailability(e.target.getAttribute("data-index"));

        if (e.target.getAttribute("data-option") === "Cor") {

            const urlToFetch = `/products/${e.target.getAttribute("data-product-handle")}?option_values=${e.target.getAttribute("data-value-id")}`;

            fetch(urlToFetch).then((response) => response.text().then((response) => {
                const element = document.createElement("div");
                element.innerHTML = response;

                document.querySelector(".product-single__gallery").innerHTML = element.querySelector(".product-single__gallery").innerHTML;
                document.querySelector('.featured-product').initProductSlider()



            }));
        }

        this.changePrice();
    }



    changeImage(productIndex) {
        const variant = this.getSelectedVariant(productIndex);

        const imageContainer = document.querySelector(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"] .custom-bundle-pdp-variant-image`);
        const imgElement = imageContainer.querySelector("img");

        if (imgElement && variant && variant.image) {
            imgElement.src = variant.image;
            imgElement.alt = variant.options.join(", ");
            imgElement.srcset = `${variant.image} 100w`;
            imgElement.loading = "lazy";
        }


    }

    getSelectedVariant(productIndex) {
        const selectedOptions = [];
        const optionContainers = this.querySelectorAll(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"] .custom-bundle-pdp-labels-container`);
        const productId = this.querySelector(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"]`).getAttribute("data-product-id");

        optionContainers.forEach(container => {
            const selectedInput = container.querySelector(".custom-bundle-pdp-radio:checked");
            if (selectedInput) {
                selectedOptions.push(selectedInput.value);
            }
        });
        const matchingVariant = this.variants.find((v) => v.product == productId).variants.find(variant => {
            return variant.options.every((option, index) => option === selectedOptions[index]);
        });

        return matchingVariant;
    }

    changeSelectedImage(image) {
        image = image.target.closest(".custom-bundle-pdp-image");
        document.querySelector(`.custom-bundle-pdp-images .custom-bundle-pdp-image[selected="true"]`).setAttribute("selected", "false");
        image.setAttribute("selected", "true");
    }

    changeOptionsAvailability(productIndex = 0) {
        const productId = this.querySelector(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"]`).getAttribute("data-product-id");
        const variants = this.variants.find((v) => v.product == productId)?.variants;
        // Seleciona o contêiner do produto baseado no índice
        const productContainer = document.querySelector(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"]`);

        // Coleta todas as opções selecionadas atualmente
        const selectedOptions = {};
        productContainer.querySelectorAll('.custom-bundle-pdp-options-wrapper').forEach(wrapper => {
            const optionType = wrapper.dataset.option;
            const selectedInput = wrapper.querySelector('input[type="radio"]:checked');
            if (selectedInput) {
                selectedOptions[optionType] = selectedInput.value;
            }
        });

        // Atualiza a disponibilidade das opções
        productContainer.querySelectorAll('.custom-bundle-pdp-options-wrapper').forEach(wrapper => {
            const optionType = wrapper.dataset.option;

            // Itera por cada opção dentro do tipo atual
            wrapper.querySelectorAll('.custom-bundle-pdp-option-wrapper').forEach(optionWrapper => {
                const input = optionWrapper.querySelector('input[type="radio"]');
                const optionValue = input.value;

                // Simula as opções combinadas com a seleção atual
                const simulatedOptions = { ...selectedOptions, [optionType]: optionValue };

                // Verifica se a combinação existe nos variantes disponíveis
                const isAvailable = variants.some(variant => {
                    return (
                        variant.options.every((value, index) => {
                            const optionName = Object.keys(selectedOptions)[index];
                            return simulatedOptions[optionName] === value;
                        }) && variant.available
                    );
                });

                // Atualiza o estado da opção (desabilitada ou não)
                if (isAvailable) {
                    input.disabled = false;
                    optionWrapper.setAttribute("available", "true");
                } else {
                    input.disabled = true;
                    optionWrapper.setAttribute("available", "false");
                }
            });
        });
    }

    formatProduct(variant) {
        return {
            item_id: variant.id,
            item_name: variant.product,
            price: Number((variant.price / 100).toFixed(2)),
            item_variant: variant.title,
            currency: this.currency,
            quantity: 1,
            father: variant.father,
            father_id: variant.fatherId,
            father_price: variant.fatherPrice
        };
    }

    setGalleryMinHeight() {
        const gallery = document.querySelector('.product-single__gallery');
        if (!gallery) return;

        const updateHeight = () => {
            const galleryHeight = gallery.offsetHeight;
            gallery.style.minHeight = `${galleryHeight}px`;
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);
    }

    observeCartDrawer() {

        const cartDrawer = document.querySelector('.cart-drawer');

        if (cartDrawer) {
            console.log('Observer iniciado na .cart-drawer');

            const observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        console.log('Classe alterada:', cartDrawer.className);

                        if (cartDrawer.classList.contains('is-open')) {
                            console.log('.cart-drawer abriu');

                            // Inicia um observer para esperar o botão aparecer
                            const buttonObserver = new MutationObserver(() => {
                                const checkoutButton = cartDrawer.querySelector('.cartx_check_mainBtn');
                                if (checkoutButton) {
                                    console.log('Botão encontrado, clicando...');
                                    checkoutButton.click();
                                    buttonObserver.disconnect(); // Para de observar depois de clicar
                                }
                            });

                            buttonObserver.observe(cartDrawer, { childList: true, subtree: true });
                        }
                    }
                });
            });

            observer.observe(cartDrawer, { attributes: true });
        }


    }

    changePrice() {
        let totalPrice = 0;
        let totalCompareAtPrice = 0;

        const activeVariants = document.querySelectorAll('.custom-bundle-pdp-variant');

        activeVariants.forEach(variant => {
            const productIndex = variant.dataset.productIndex;

            const selectedOptions = [];
            variant.querySelectorAll('.custom-bundle-pdp-options-wrapper').forEach(optionWrapper => {
                const selectedInput = optionWrapper.querySelector('input[type="radio"]:checked');
                if (selectedInput) {
                    selectedOptions.push(selectedInput.value);
                }
            });

            const productId = this.querySelector(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"]`).getAttribute("data-product-id");
            variants = this.variants.find((v) => v.product == productId)?.variants;

            const matchingVariant = variants.find(v => {
                return v.options.every((option, index) => option === selectedOptions[index]);
            });

            let variantPrice = 0;
            let compareAtPrice = 0;

            if (matchingVariant) {
                if (matchingVariant.discount) variantPrice = matchingVariant.price * (100 - parseInt(matchingVariant.discount)) / 100;
                compareAtPrice = matchingVariant.compareAtPrice;
            }

            totalCompareAtPrice += compareAtPrice;
            totalPrice += variantPrice;
        });


        totalPrice = totalPrice / 100;
        totalCompareAtPrice = totalCompareAtPrice / 100;

        const pixPrice = 0.98 * totalPrice;

        this.closest(".product-single__details").querySelector(".product__price--regular").innerText = `R$ ${pixPrice.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} no pix`;
        this.closest(".product-single__details").querySelector(".product__price--compare").innerText = `R$ ${totalCompareAtPrice.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        this.closest(".product-single__details").querySelector(".product__price--installments").innerText = `R$ ${totalPrice.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} no cartão ou em 3x de R$ ${(totalPrice / 3).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} sem juros`;
    }

    async addToCart() {
        this.querySelector(".custom-bundle-pdp-buy-button").classList.add("is-loading");

        const activeVariants = document.querySelectorAll('.custom-bundle-pdp-variant');
        const cartItems = [];

        let totalPrice = 0;
        const formattedProducts = [];

        activeVariants.forEach(variant => {
            const productIndex = variant.dataset.productIndex;

            const selectedOptions = [];
            variant.querySelectorAll('.custom-bundle-pdp-options-wrapper').forEach(optionWrapper => {
                const selectedInput = optionWrapper.querySelector('input[type="radio"]:checked');
                if (selectedInput) {
                    selectedOptions.push(selectedInput.value);
                }
            });

            const productId = this.querySelector(`.custom-bundle-pdp-variant[data-product-index="${productIndex}"]`).getAttribute("data-product-id");
            variants = this.variants.find((v) => v.product == productId)?.variants;

            const matchingVariant = variants.find(v => {
                return v.options.every((option, index) => option === selectedOptions[index]);
            });

            if (matchingVariant && matchingVariant.available) {
                cartItems.push({
                    id: matchingVariant.id,
                    quantity: 1
                });
                formattedProducts.push(this.formatProduct(matchingVariant));
                totalPrice += matchingVariant.price;
            }
        });


        let formData = new FormData();

        cartItems.forEach((item) => {
            formData.append('items[][id]', item.id);
            formData.append('items[][quantity]', item.quantity);
        })


        await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        }).then(response => response.json())
            .then(data => {

                window.cartDrawer.getCart();

                window.dataLayer.push({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: this.currency,
                        value: Number((totalPrice / 100).toFixed(2)),
                        items: [formattedProducts],
                    },
                })

                window.VWO = window.VWO || [];
                VWO.event = VWO.event || function () {
                    VWO.push(["event"].concat([].slice.call(arguments)));
                };

                const firstProduct = formattedProducts[0];

                VWO.event("shopify.productAddedToCart", {
                    currency: firstProduct.currency,
                    productId: String(firstProduct.father_id),
                    productTitle: firstProduct.father,
                    quantity: 1,
                    totalAmount: firstProduct.father_price,
                    variantId: "Kit Customizado"
                });

                this.querySelector(".custom-bundle-pdp-buy-button").classList.remove("is-loading");
            })

    }

}

customElements.define("custom-bundle-pdp", CustomBundlePDP);

class BundleTypeSelector extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.querySelectorAll(".bundle-type-select-header span").forEach((item) => item.addEventListener("click", this.selectType.bind(this, item)));
    }

    selectType(type) {
        this.querySelectorAll(".bundle-type-select-header span").forEach((item) => {
            item.setAttribute("data-selected", "false");
        });

        type.setAttribute("data-selected", "true");

        this.setAttribute("data-selected", type.getAttribute("data-type"));

        document.querySelector(".product__info-container").setAttribute("data-type-bundle-selected", type.getAttribute("data-type"));

        if (type.getAttribute("data-type") == "default") {


            const urlToFetch = `/products/${this.getAttribute("data-product-handle")}`;

            fetch(urlToFetch).then((response) => response.text().then((response) => {
                const element = document.createElement("div");
                element.innerHTML = response;

                document.querySelector(".product-single__gallery").innerHTML = element.querySelector(".product-single__gallery").innerHTML;
                document.querySelector('.featured-product').initProductSlider()

                const elemento = document.querySelector("[data-single-option-selector]");
                const evento = new Event('change');
                elemento.dispatchEvent(evento);


            }));

        }
    }
}

if (!customElements.get('bundle-type-select')) {
    customElements.define('bundle-type-select', BundleTypeSelector);
}

